import React,{ useState,useEffect } from 'react';
import Backdrop from '@material-ui/core/Backdrop';
import CircularProgress from '@material-ui/core/CircularProgress';
import Button from '@material-ui/core/Button';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff',
  },
}));

export default function SimpleBackdrop(props) {
  const classes = useStyles();
  let temp = props.parentLoadStatus
  const [open, setOpen] = React.useState(temp);

  const handleClose = () => {
    setOpen(false);
  };
  const handleToggle = () => {
    setOpen(!open);
  };

  useEffect(() => {
      setOpen(temp)
  },[temp])

  return (
    <div>
     
      <Backdrop className={classes.backdrop} open={open}>
        <CircularProgress color="inherit" />
        
      </Backdrop>
    </div>
  );
}